import * as React from "react"
import "../styles/styles.sass"
import SidebarNavigation from "../components/sidebarNavigation"
import TitleBar from "../components/titleBar"
import ListRow from "../components/list"

// Markup
const IndexPage = () => {
  return (
    <main className="lighthouseView componentsView">
      <title>Components</title>
      <SidebarNavigation />

      <div className="viewWindow">
        <TitleBar title="Components" actions=""/>

        <div className="viewContent">
          <div className="list">
            <div className="listSection">
              <div className="listGroup">
                <ListRow
                  link="/components/activity-indicator"
                  icon=""
                  title="Activity Indicator"
                  detail="none"
                  accessory="chevron"
                />

                <ListRow
                  link="/components/alert"
                  icon=""
                  title="Alert"
                  detail="none"
                  accessory="chevron"
                />

                <ListRow
                  link="/components/button"
                  icon=""
                  title="Button"
                  detail="none"
                  accessory="chevron"
                />

                <ListRow
                  link="/components/checkbox"
                  icon=""
                  title="Checkbox"
                  detail="none"
                  accessory="chevron"
                />

                <ListRow
                  link="/components/form"
                  icon=""
                  title="Form"
                  detail="none"
                  accessory="chevron"
                />

                <ListRow
                  link="/components/radio"
                  icon=""
                  title="Radio Button"
                  detail="none"
                  accessory="chevron"
                />

                <ListRow
                  link=""
                  icon=""
                  title="Search Bar"
                  detail="trailing"
                  detailText="NOT READY"
                  accessory="none"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  )
}

export default IndexPage
